/* generated by pull.js */
const manifest = {
  name: 'Pause button',
  description: 'Adds a button to pause the project next to the green flag.',
  info: [
    {
      text: 'The project can also be paused with Alt+X (Option+X on macOS).',
      id: 'keybind'
    }
  ],
  credits: [
    {
      name: 'Jeffalo'
    },
    {
      name: 'GarboMuffin'
    }
  ],
  dynamicDisable: true,
  userscripts: [
    {
      url: 'userscript.js'
    }
  ],
  userstyles: [
    {
      url: 'style.css'
    }
  ],
  tags: ['recommended'],
  enabledByDefault: true
};
export default manifest;
